import { useRef, useState, useEffect } from 'react';

export const useOnScreen = (initialState?: boolean) => {
    const ref = useRef<HTMLDivElement>(null);
    const [isVisble, setIsVisible] = useState(!!initialState);

    useEffect(() => {
        if (!ref?.current) {
            return;
        }
        const observer = new IntersectionObserver(([entry]) => {
            setIsVisible(entry.isIntersecting);
        });

        observer.observe(ref.current);
        // Remove the observer as soon as the component is unmounted
        return () => observer.disconnect();
    }, []);

    return { isVisble, ref };
};
